@if (iconClass) {
  <campus-icon [svgIcon]="iconClass"></campus-icon>
  } <ng-content></ng-content>
